export const FETCH_NEIGHBOURHOODS_REQUEST = "FETCH_NEIGHBOURHOODS_REQUEST";
export const FETCH_ALL_NEIGHBOURHOODS_REQUEST = "FETCH_ALL_NEIGHBOURHOODS_REQUEST";
export const FETCH_NEIGHBOURHOOD_DETAIL_REQUEST = "FETCH_NEIGHBOURHOOD_DETAIL_REQUEST";
export const UPDATE_NEIGHBOURHOOD_REQUEST = "UPDATE_NEIGHBOURHOOD_REQUEST";
export const CHANGE_NEIGHBOURHOOD_STATUS_REQUEST = "CHANGE_NEIGHBOURHOOD_STATUS_REQUEST";
export const CREATE_NEIGHBOURHOOD_REQUEST = "CREATE_NEIGHBOURHOOD_REQUEST";
export const CHANGE_NEIGHBOURHOOD_WEIGHT_REQUEST = "CHANGE_NEIGHBOURHOOD_WEIGHT_REQUEST";
